<template>
  <div>
    <b-card no-body v-if="$can('create', 'Ratio Cosecha Re')">
      <b-card-body>
        <b-row>
          <b-col
              cols="12"
              md="2"
              class="mb-md-0 mb-2"
          >

            <b-form-group>
              <label>Rango de fecha</label>
              <flat-pickr
                  id="rangeFecha"
                  v-model="rangeDate"
                  class="form-control"
                  :config="{
                    mode: 'range',
                    dateFormat: 'd/m/Y',
                    defaultDate: [new Date(), new Date()],
                    locale: 'es',
                     maxDate: new Date(),

                  }"

              />
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              md="4"
              class="mb-md-0 mb-2"
          >
            <label>&nbsp;</label>
            <br>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="success"
                @click="validadEntrada"
            >
              <feather-icon
                  icon="PlusIcon"
                  class="mr-50"
              />
              <span class="align-middle">Ejecutar</span>

            </b-button>
            &nbsp;
            <div v-if="show" class="spinner-border text-primary" role="status" style="width: 1.3rem; height: 1.3rem;">

            </div>

          </b-col>

        </b-row>
      </b-card-body>
    </b-card>

    <b-card no-body >
      <b-card-body class="px-1 pt-1 pb-0">
        <b-row>
          <!-- Per Page -->
          <b-col
              xl="2"
              md="9"
              sm="6"
          >
            <b-form-group v-if="showRangeFecha">
              <label>Rango fecha tareo</label>
              <flat-pickr
                  id="rangeFechaFil"
                  v-model="rangeDateFil"
                  class="form-control"
                  :config="{
                    mode: 'range',
                    dateFormat: 'd/m/Y',
                    locale: 'es',

                  }"
                  style="height: 31px"

              />
            </b-form-group>
          </b-col>
          <b-col
              xl="2"
              md="9"
              sm="6"
          >
            <b-form-group
                label="Actividad"
                label-for="actividad"
            >
              <v-select
                  id="actividad"
                  v-model="actividadSelected"
                  :options="actividad"
                  :reduce="actividad => actividad.value"
                  label="text"
                  key="value"
                  placeholder="Seleccionar..."
              />
            </b-form-group>

          </b-col>
          <b-col
              xl="2"
              md="9"
              sm="6"
          >
            <b-form-group
                label="Etapa"
                label-for="idetapa"
            >
              <v-select
                  id="idetapa"
                  v-model="etapaSelected"
                  :options="etapaOpt"
                  :reduce="etapaOpt => etapaOpt.value"
                  label="text"
                  key="value"
                  placeholder="Seleccionar..."
                  @input="filtrarCombox"
              />
            </b-form-group>

          </b-col>
          <b-col
              xl="2"
              md="9"
              sm="6"
          >
            <b-form-group
                label="Campo"
                label-for="idcampo"
            >
              <v-select
                  id="idcampo"
                  v-model="campoSelected"
                  :options="campoOpt"
                  :reduce="campoOpt => campoOpt.value"
                  label="text"
                  key="value"
                  placeholder="Seleccionar..."
                  @input="filtrarVariedad"
              />
            </b-form-group>

          </b-col>
          <b-col
              xl="2"
              md="9"
              sm="6"
          >
            <b-form-group
                label="Variedad"
                label-for="idvariedad"
            >
              <v-select
                  id="idvariedad"
                  v-model="variedadSelected"
                  :options="variedadOpt"
                  :reduce="variedadOpt => variedadOpt.value"
                  label="text"
                  key="value"
                  placeholder="Seleccionar..."
              />
            </b-form-group>

          </b-col>

          <b-col
              xl="2"
              md="9"
              sm="6"
              class="mb-md-0 mb-2"
          >
            <b-form-group
                label=""
                label-for="id_cultivo"
            >
              <label>&nbsp;</label>
              <br>
              <b-button
                  variant="gradient-primary"
                  size="sm"
                  @click="filtrarLista"
              >
                <feather-icon
                    icon="PlusIcon"
                    class="mr-50"
                />
                <span class="align-middle">Filtrar</span>
              </b-button>
            </b-form-group>

          </b-col>


          <!-- Search -->
        </b-row>
      </b-card-body>
    </b-card>
    <b-card no-body >
      <b-card-body >

        <div class="d-flex justify-content-between  flex-wrap">
          <!-- Registar categoría  -->
          <b-form-group
              label-for="filterInput"
              class="mb-0"
          >
            <b-button
                variant="gradient-primary"
                size="sm"
                class="mr-1"
                @click="filtrarLista"
            >

              <feather-icon
                  icon="RefreshCwIcon"
              />
            </b-button>
            <b-button
                variant="gradient-success"
                size="sm"
                @click="descargarFiless()"
                v-if="false"
            >
              <feather-icon
                  icon="PlusIcon"
                  class="mr-50"
              />
              <span class="align-middle">Exportar</span>
            </b-button>

          </b-form-group>

          <!-- filter -->
          <b-form-group
              label-for="filterInput"
              class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                  id="filterInput"
                  v-model="filter"
                  type="search"
                  placeholder="Buscar"
                  :disabled="loading"
                  @input="filtros2"
                  size="sm"
              />
              <b-input-group-append>
                <b-button
                    :disabled="!filter"
                    @click="filter = ''"
                >
                  Borrar
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

        </div>

      </b-card-body>

      <b-table
          v-if="$can('read', 'Ratio Cosecha Re')"
          hover
          responsive
          class="position-relative"
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="cPaginacion"
          :busy="loading"
          show-empty
          empty-text="No se encontraron datos en esta tablas."
          emptyFilteredText="No se encontraron datos con los parámetros ingresados."
      >
        <!--
        <template #cell(fecha_n)="data">
          {{ data.value }} @ {{ data.value.split('-')[2] }}/{{ data.value.split('-')[1] }}/{{ data.value.split('-')[0] }}
        </template>
        -->

        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>

        <template #cell(nuevo_empresa)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>
        <template #cell(nuevo_empresa)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>
        <template #cell(nuevo_cosecha)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>

      </b-table>

      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <!-- page length -->
        <b-form-group
            label="Mostrar"
            label-cols="5"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
              id="perPageSelect2"
              v-model="perPage"
              size="sm"
              inline
              :options="pageOptions"
          />

        </b-form-group>

        <!-- pagination -->
        <div>
          <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-0"
          >
            <template #prev-text>
              <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>

    </b-card>
  </div>

</template>

<script>
import axiosIns from '../../../libs/axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import flatPickr from 'vue-flatpickr-component'
import { Spanish } from "flatpickr/dist/l10n/es.js"

import {
  BCard,
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BTooltip,
  BModal,
  VBModal,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol, BSpinner
} from 'bootstrap-vue'
import axios from "axios";
import alert from '@/views/components/alert/Alert'

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    vSelect,
    ToastificationContent,
    BSpinner,
    flatPickr,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {

      perPage: 5,
      pageOptions: [5, 10, 15],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      estadoModal: false,
      showRangeFecha:true,
      showFecha:true,
      src: '',
      infoModal: {
        title: '',
        boton: '',
      },
      fields: [
        {
          key: 'empresa',
          label: 'Empresa',
          sortable: true
        },
        {
          key: 'dni_trabajador',
          label: 'DNI',
          sortable: true
        },
        {
          key: 'nombres_trabajador',
          label: 'TRABAJADOR',
          sortable: true
        },
        {
          key: 'nombre_actividad',
          label: 'Actividad',
          sortable: true
        },
        {
          key: 'nombre_labor',
          label: 'Labor',
          sortable: true
        },
        {
          key: 'idconsumidor',
          label: 'Consumidor',
          sortable: true
        },
        {
          key: 'fecha_tareo',
          label: 'FECHA TAREO',
          sortable: true
        },
        {
          key: 'ratio',
          label: 'Ratio',
          sortable: true
        },
        {
          key: 'meta_ratio_bono',
          label: 'Meta ratio bono',
          sortable: true
        },
        {
          key: 'cumplimiento_bono',
          label: 'cumplimiento bono %',
          sortable: true
        },
        {
          key: 'meta_ratio_cuadrilla',
          label: 'meta ratio cuadrilla',
          sortable: true
        },
        {
          key: 'cumplimiento_cuadrilla',
          label: 'cumplimiento cuadrilla %',
          sortable: true
        },
      ],
      items: [],
      itemsData:[],
      status: [
        {
          1: 'Nuevo',
          2: 'Antiguo',
          3: 'Sin contrato',
        },
        {
          1: 'light-success',
          2: 'light-warning',
          3: 'light-danger',
        }
      ],
      loading: false,
      estadoEmpresa_: [
        {value: 'T', text: "TODOS"},
        {value: '1', text: "NUEVO"},
        {value: '2', text: "ANTIGUO"},
        {value: '3', text: "OTROS"},
      ],
      estadoEmpresa_Selected: null,
      estadoCosecha: [
        {value: 'T', text: "TODOS"},
        {value: '1', text: "NUEVO"},
        {value: '2', text: "ANTIGUO"},
        {value: '3', text: "OTROS"},
      ],
      estadoCosechaSelected: null,
      selected: null,
      options: [
        { value: null, text: 'Cosecha ' },
      ],
      nuevo_dias:'',
      culivo_:'',
      show: false,
      tipoOptionsSelected: null,
      tipoOptions: [
        {value: '0', text: "FECHA ESPECIFICA"},
        {value: '1', text: "RANGO FECHA"}
      ],
      fechaSelect:'',
      rangeDate: null,
      rangeDateFil:null,
      actividad:[{
        "value":'T',
        "text":'TODAS'
      }],
      actividadSelected:'T',
      etapaOpt:[
        {
          "value":'T',
          "text":'TODAS'
        }
      ],
      etapaSelected:'T',
      campoOpt:[
        {
          "value":'T',
          "text":'TODAS'
        }
      ],
      campoSelected:'T',
      variedadOpt:[
        {
          "value":'T',
          "text":'TODAS'
        }
      ],
      variedadSelected:'T',
      labor_:[],
      laborSelected_:'',
      cbxEtapaCampoVariedad:[],
      arrayCampo:[],



    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key
          }))
    },
  },
  mounted() {
    this.llenarActividad();
    this.getLlenarComboxEtapaCampoVariedad();
    this.validadEntradaRangeFiltro('1');

  },
  methods: {
    listarBajaProductividad(fechaInicioRange,fechaFinRange){
      var yo = this


      yo.loading = true;


      if(yo.actividadSelected == '' || yo.actividadSelected == null){
        yo.actividadSelected = yo.actividad[0].value;
      }
      if(yo.etapaSelected == '' || yo.etapaSelected == null){
        yo.etapaSelected = yo.etapaOpt[0].value;
      }
      if(yo.campoSelected == '' || yo.campoSelected == null){
        yo.campoSelected = yo.campoOpt[0].value;
      }
      if(yo.variedadSelected == '' || yo.variedadSelected == null){
        yo.variedadSelected = yo.variedadOpt[0].value;
      }

      var body =  "" +
          "fecha_inicial=" +fechaInicioRange+'&'+
          "fecha_final=" +fechaFinRange+'&'+
          "actividad=" +yo.actividadSelected+'&'+
          "etapa=" +yo.etapaSelected+'&'+
          "campo=" +yo.campoSelected+'&'+
          "variedad=" + yo.variedadSelected+
          "";

      var config = {
        method: 'get',
        url: '/cosecha/cosecha/bajaProductividadRatio/list/?'+body,
        headers: { },
      };


      axiosIns(config)
          .then((response) => {
            yo.items = response.data.response;
            yo.itemsData = yo.items;
            yo.totalRows = yo.items.length
            //console.log(yo.items);
          })
          .catch(function (error) {
            console.log(error);
          }).finally(function (){
        yo.loading = false
      });

    },
    getLlenarComboxEtapaCampoVariedad(){
      var yo = this

      yo.cbxEtapaCampoVariedad = [];


      var config = {
        method: 'get',
        url: '/cosecha/cosecha/getConsumidoresEtapaCampo/all/',
      };
      axiosIns(config)
          .then(function (response) {

            yo.cbxEtapaCampoVariedad = response.data.respuesta;
            yo.arrayCampo = yo.cbxEtapaCampoVariedad;
            yo.etapaOpt = [];
            yo.campoOpt = [];
            yo.variedadOpt = [];
            for (let value of yo.cbxEtapaCampoVariedad){
              if (value.etapa != null && value.etapa !== '' && value.etapa !== ' ' && value.etapa !== '  ')
              {
                yo.etapaOpt.push({value: value.etapa, text:value.etapa});
              }
              if (value.campo != null && value.campo !== '' && value.campo !== ' ' && value.campo !== '  ')
              {
                yo.campoOpt.push({value: value.campo, text:value.campo});
              }
              if (value.variedad != null && value.variedad !== '' && value.variedad !== ' ' && value.variedad !== '  ')
              {
                yo.variedadOpt.push({value: value.variedad, text:value.variedad});
              }
            }
            let setEtapa   = new Set( yo.etapaOpt.map( JSON.stringify ) );
            yo.etapaOpt = Array.from(setEtapa).map(JSON.parse);
            yo.etapaOpt.unshift({value: 'T', text:"TODAS"});
            yo.etapaSelected = "T";

            let setCampo   = new Set( yo.campoOpt.map( JSON.stringify ) );
            yo.campoOpt = Array.from(setCampo).map(JSON.parse);
            yo.campoOpt.unshift({value: 'T', text:"TODAS"});
            yo.campoSelected = "T";

            let setVariedad   = new Set( yo.variedadOpt.map( JSON.stringify ) );
            yo.variedadOpt = Array.from(setVariedad).map(JSON.parse);
            yo.variedadOpt.sort((a,b)=>(a.value > b.value ? 1 : -1));
            yo.variedadOpt.unshift({value: 'T', text:"TODAS"});
            yo.variedadSelected = "T";

          })
          .catch(function (error) {
            console.log(error);
          });

    },
    filtrarLista(){
      var yo = this
      yo.validadEntradaRangeFiltro('2');

    },
    addHoursToDate(objDate, intHours) {
      var numberOfMlSeconds = objDate.getTime();
      var addMlSeconds = (intHours * 60) * 60000;
      var newDateObj = new Date(numberOfMlSeconds + addMlSeconds);

      return newDateObj;
    },
    abrir(fecha_inicial,fecha_final){

      var yo = this


      this.$swal({
        title: '¿Está seguro?',
        text: "¿Desea generar  los ratios para el personal de cosecha?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-danger',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          yo.insertDataPersonal(fecha_inicial,fecha_final);
          //yo.insertDataLog(12,12,12);
        }
      })

      //this.estadoModal = true;
    },
    validadEntrada(){
      const yo = this
      let fecha = yo.rangeDate;

      if(fecha !== null && fecha !== '') {
        let fecha_array = fecha.split(' a ')
        let fechaInicio = ''
        let fechaFin = ''
        if(fecha_array.length == 2){
          let sep_feha_in = fecha_array[0].split('/');
          let sep_feha_fin = fecha_array[1].split('/');
          fechaInicio = sep_feha_in[2]+"-"+sep_feha_in[1]+"-"+sep_feha_in[0]
          fechaFin = sep_feha_fin[2]+"-"+sep_feha_fin[1]+"-"+sep_feha_fin[0]
          var day1Inicial = new Date(fechaInicio);
          var day2Final = new Date(fechaFin);
          var difference= Math.abs(day2Final-day1Inicial);
          var days = (difference/(1000 * 3600 * 24))+1;
          if(days<=16){
            yo.abrir(fechaInicio,fechaFin);
          }else{
            yo.$swal.fire(
                'Mensaje',
                'El rango de fecha seleccionado supera los 15 días!',
                'warning'
            ).then((result) => {
            });
          }
        }else{
          yo.$swal.fire(
              'Mensaje',
              'Falta ingresar una fecha!',
              'warning'
          ).then((result) => {
          });
        }

      }else{
        yo.$swal.fire(
            'Mensaje',
            'Debe selecionar una fecha inicial y final',
            'warning'
        ).then((result) => {
        });
      }


    },
    validadEntradaRangeFiltro(tipo){

      const yo = this
      let fechaRangeTareo = yo.rangeDateFil;
      let fechaInicioRange = ''
      let fechaFinRange = ''

      if(fechaRangeTareo == null || fechaRangeTareo == '') {

        if(tipo == '1'){

          let date_Actual = new Date();
          let date_inicial = yo.addHoursToDate(date_Actual,-240);
          let date_final = yo.addHoursToDate(date_Actual,-24);
          var fecha_inicial = date_inicial.getFullYear() +'-' + String(date_inicial.getMonth() + 1).padStart(2, '0')+'-'+ String(date_inicial.getDate()).padStart(2, '0');
          var fecha_final = date_final.getFullYear() +'-' + String(date_final.getMonth() + 1).padStart(2, '0')+'-'+ String(date_final.getDate()).padStart(2, '0');
          var fecha_inicial_f = String(date_inicial.getDate()).padStart(2, '0')+'/'+String(date_inicial.getMonth() + 1).padStart(2, '0')+'/'+date_inicial.getFullYear();
          var fecha_final_f = String(date_final.getDate()).padStart(2, '0')+'/'+String(date_final.getMonth() + 1).padStart(2, '0')+'/'+date_final.getFullYear();
          this.rangeDateFil = [fecha_inicial_f,fecha_final_f];
          fechaInicioRange = fecha_inicial;
          fechaFinRange = fecha_final;
          yo.listarBajaProductividad(fechaInicioRange,fechaFinRange);

        }else{

          yo.$swal.fire(
              'Mensaje',
              'Debe selecionar una fecha',
              'warning'
          ).then((result) => {
          });
        }

      }else{

        let fecha_array = fechaRangeTareo.split(' a ')

        if(fecha_array.length == 2){
          let sep_feha_in = fecha_array[0].split('/');
          let sep_feha_fin = fecha_array[1].split('/');
          fechaInicioRange = sep_feha_in[2]+"-"+sep_feha_in[1]+"-"+sep_feha_in[0];
          fechaFinRange = sep_feha_fin[2]+"-"+sep_feha_fin[1]+"-"+sep_feha_fin[0];

          var day1Inicial = new Date(fechaInicioRange);
          var day2Final = new Date(fechaFinRange);
          var difference= Math.abs(day2Final-day1Inicial);
          var days = (difference/(1000 * 3600 * 24))+1;
          if(days<=16){
            yo.listarBajaProductividad(fechaInicioRange,fechaFinRange);
          }else{
            yo.$swal.fire(
                'Mensaje',
                'El rango de fecha seleccionado supera los 16 días!',
                'warning'
            ).then((result) => {
            });
          }
        }else{
          let sep_feha_in = fecha_array[0].split('/');
          fechaInicioRange = sep_feha_in[2]+"-"+sep_feha_in[1]+"-"+sep_feha_in[0];
          fechaFinRange = sep_feha_in[2]+"-"+sep_feha_in[1]+"-"+sep_feha_in[0];
          yo.listarBajaProductividad(fechaInicioRange,fechaFinRange);
        }

      }


    },

    ejecutarBaja(){

      var yo = this


      this.$swal({
        title: '¿Está seguro?',
        text: "¿Desea generar  baja productividad?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-danger',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          yo.insertDataPersonal();
        }
      })
    },


    insertDataPersonal(fecha_inicial,fecha_final){

      var yo = this

      yo.show=true;
      this.$swal.fire({
        title: 'Generando...',
        text: 'Por favor espere, se está generando los ratios del personal de cosecha',
        footer: "No cierre la ventana",
        //imageUrl:'https://upload.wikimedia.org/wikipedia/commons/c/c7/Loading_2.gif?20170503175831',
        //imageUrl:"https://adhana.com/wp-content/uploads/2019/03/spinner.gif",
        //imageUrl:"http://tramites.urcuqui.gob.ec/sisplan/modulos/obtencion/imgs/loading.gif",
        imageUrl:require('@/assets/images/loading/loading.gif'),
        //imageUrl:"https://static.wixstatic.com/media/680d86_8cd61a3eedbd41fba383c945214a3508~mv2.gif",
        imageWidth: 200,
        imageHeight: 200,
        showCancelButton: false, // There won't be any cancel button
        showConfirmButton: false // There won't be any confirm button
      })

      var qs = require('qs');
      var data = qs.stringify({
        'fecha_inicial': fecha_inicial,
        'fecha_final': fecha_final
      });

      var config = {
        method: 'post',
        url: ('/cosecha/cosecha/ratiotrabajadorInsert/'),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data : data,
        timeout:false,
      };


      axiosIns(config)
          .then(function (response) {
            console.log("Ejecución exitosa");
            console.log(response.data);
            yo.show=false;
            yo.$swal.fire(
                'Generado!',
                'Ratios generados con éxito',
                'success'
            ).then((result) => {
              yo.filtrarLista();

            });


          })
          .catch(function (error) {
            console.log("Error en la ejecución");
            console.log(error);

            console.log(error);
            //console.log(error.stack);
            yo.show=false;


            yo.$swal.fire(
                'Error!',
                'Problema al generar El ETL',
                'error'
            ).then((result) => {
              yo.listarLog();
            });

          });



    },

    cPaginacion(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    llenarActividad(){
      var yo = this

      yo.actividad = [];
      yo.actividad.push({value: 'T', text: 'TODOS'});
      yo.actividadSelected = yo.actividad[0].value;


      var config = {
        method: 'get',
        url: '/cosecha/cosecha/actividad/list/',
      };
      axiosIns(config)
          .then(function (response) {
            var response = response.data;
            var totalRows = response.length
            for (var i = 0 ; i < totalRows; i++){
              var codigo_ = response[i].codigo;
              var nomnbre_= response[i].nombre.toString();

              yo.actividad.push({value: codigo_, text: nomnbre_});
            }
            //  yo.actividadSelected = yo.actividad[2].value;


          })
          .catch(function (error) {
            console.log(error);
          });
    },

    inicializacion(){

    },

    filtros2(){
      var palabra = this.filter !== null ? this.filter.toLowerCase() : ''
      this.items = this.itemsData;
      this.items = this.items.filter(
          invoice =>
              (invoice.dni_trabajador.toLowerCase().includes(palabra) || invoice.nombres_trabajador.toLowerCase().includes(palabra)))
      this.totalRows = this.items.length
    },
    filtrarCombox(){
      var yo = this;
      let data =  yo.cbxEtapaCampoVariedad;
      yo.campoOpt = [];
      yo.variedadOpt = [];
      yo.arrayCampo = data;

      if(yo.etapaSelected != 'T'){
        yo.arrayCampo = data.filter(etapa => etapa.etapa == yo.etapaSelected)
      }

      for (let value of yo.arrayCampo){
        if (value.campo != null && value.campo !== '' && value.campo !== ' ' && value.campo !== '  ')
        {
          yo.campoOpt.push({value: value.campo, text:value.campo});
        }
        if (value.variedad != null && value.variedad !== '' && value.variedad !== ' ' && value.variedad !== '  ')
        {
          yo.variedadOpt.push({value: value.variedad, text:value.variedad});
        }
      }
      let setCampo   = new Set( yo.campoOpt.map( JSON.stringify ) );
      yo.campoOpt = Array.from(setCampo).map(JSON.parse);
      yo.campoOpt.unshift({value: 'T', text:"TODAS"});
      yo.campoSelected = "T";

      let setVariedad   = new Set( yo.variedadOpt.map( JSON.stringify ) );
      yo.variedadOpt = Array.from(setVariedad).map(JSON.parse);
      yo.variedadOpt.sort((a,b)=>(a.value > b.value ? 1 : -1));
      yo.variedadOpt.unshift({value: 'T', text:"TODAS"});
      yo.variedadSelected = "T";



    },
    filtrarVariedad(){

      var yo = this;
      let data =  yo.arrayCampo;

      yo.variedadOpt = [];
      let arrayVariedad= data;
      if(yo.campoSelected != 'T'){
        arrayVariedad = data.filter(campo => campo.campo == yo.campoSelected);
      }

      for (let value of arrayVariedad){
        if (value.variedad != null && value.variedad !== '' && value.variedad !== ' ' && value.variedad !== '  ')
        {
          yo.variedadOpt.push({value: value.variedad, text:value.variedad});
        }
      }

      let setVariedad   = new Set( yo.variedadOpt.map( JSON.stringify ) );
      yo.variedadOpt = Array.from(setVariedad).map(JSON.parse);
      yo.variedadOpt.sort((a,b)=>(a.value > b.value ? 1 : -1));
      yo.variedadOpt.unshift({value: 'T', text:"TODAS"});
      yo.variedadSelected = "T";


    }





  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
